var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","max-width":_vm.maxWidth},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_vm._t("element")],2)]}}],null,true)},[_vm._t("default"),_vm._t("hover-text")],2)}
var staticRenderFns = []

export { render, staticRenderFns }